/**
 * Multiple choice input component for questions
 */
export const MultipleChoiceInput = ({ questionId, options, value, onChange, disabled, saving }) => {
  if (!options || options.length === 0) return null;

  return (
    <div className="space-y-3">
      {options.map((option, idx) => (
        <label key={idx} className="block">
          <div className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
            value === option
              ? 'border-emerald-500 dark:border-emerald-400 bg-emerald-50 dark:bg-emerald-900/30'
              : 'border-gray-200 dark:border-gray-700 hover:border-emerald-300 dark:hover:border-emerald-600'
          }`}>
            <div className="flex items-start">
              <input
                type="radio"
                name={`question-${questionId}`}
                value={option}
                checked={value === option}
                onChange={(e) => onChange(questionId, 'answer', e.target.value)}
                className="mt-1 mr-3 text-emerald-600 dark:text-emerald-400"
                disabled={disabled || saving}
              />
              <span className="text-gray-800 dark:text-gray-200 leading-relaxed">{option}</span>
            </div>
          </div>
        </label>
      ))}
    </div>
  );
};

